<!-- TODOs
    1. Update Radio and checkbox with goNext Only
    2. Show Feedback faces after the form
 -->
<template>
  <main>
    <div class="page-headline m-b-30 m-t-70 align-center">
      <h1 class="headline page-headline__title m-b-20">{{ pageInfo.title }}</h1>
      <h4 class="tagline page-headline__tagline" v-html="pageInfo.content"></h4>
    </div>
    <div class="align-center estimation">
      <div class="container">
        <p>
          {{ $t("global.projectEstimation") }}
          <strong>{{ projectEstimation }} USD</strong>
        </p>
      </div>
    </div>
    <div class="container">
      <div class="question-wrapper" v-for="question in surveyQuestions" v-if="!showForm" :key="question.id">
        <div class="question m-b-30 align-center">
          <h1 class="question__text">
            <strong class="question__number">
              0{{ questionNumber }}
            </strong>
            {{ question.title }}
          </h1>
        </div>
        <div class="answer center-md center-xs row m-b-30">
          <div class="col-md-2 col-sm-4 col-xs-12" v-for="option in question.options" :key="option.id">
            <div class="align-center answer__option">
              <label>
                <input type="checkbox" :name="question.id" :value="option.id" :question="question.id" :selectedOptionValue="option.value" @change="optionCheckboxSelected($event, option, question.id)" v-model="checkedOptions" :checked="isChecked" v-if="showGoNext" />
                <input type="radio" :name="question.id" :value="option.id" :question="question.id" @change="optionSelected(option, question.id)" :checked="isChecked" v-else/>
                <div class="box">
                  <object slot="image" class="answer__option__image" :id="option.id" type="image/svg+xml" :data="option.image_url"></object>
                  <h1 class="answer__option__text m-t-10 m-b-30">{{ option.title }}</h1>
                  <span class="circle"></span>
                </div>
              </label>
            </div>
          </div>
        </div>
        <div class="row center-md between-md center-xs around-xs m-b-30">
          <a class="button button--primary button--primary__small" v-on:click.prevent="goBack()" v-if="showGoBack">
            <span class="button--primary__text">{{ $t("global.goBack") }}</span>
          </a>
          <button class="button button--primary button--primary__small" :disabled="goNextIsDisabled" v-on:click.prevent="goNext()" v-if="showGoNext">
            <span class="button--primary__text">{{ $t("global.goNext") }}</span>
          </button>
        </div>
      </div>
      <div v-if="showForm" class="row center-md center-xs contact-form-container pricing-form m-t-30">
        <Contact-Form form-name="get-an-estimation" :project-estimation="projectEstimation" :start-time="startTime" :user-selected-options="mylist"></Contact-Form>
      </div>
    </div>
  </main>
</template>

<script>
import ContactForm from "./modules/ContactForm";
var $ = require("jquery");

export default {
	name: "Pricing",
	data() {
		return {
			pageTitle: "Loading...",
			pageInfo: {},
			surveyQuestions: [],
			checkedOptions: [],
			tree: {},
			initList: [],
			mylist: [],
			childrenIds: [],
			NodPointer: 0,
			CurrentQuestionId: 0,
			questionNumber: 1,
			showGoBack: false,
			showGoNext: false,
			goNextIsDisabled: true,
			isChecked: false,
			showForm: false,
			projectEstimation: 0,
			startTime: 0
		};
	},
	components: {
		ContactForm
	},
	metaInfo() {
		return {
			title: this.pageTitle,
			meta: [
				{ itemprop: "name", content: this.pageInfo.meta_og_description },
				{ itemprop: "description", content: this.pageInfo.meta_og_description },
				{ name: "og:title", content: this.pageInfo.meta_og_title },
				{ name: "og:description", content: this.pageInfo.meta_og_description },
				{ name: "og:url", content: this.pageInfo.meta_url },
				{ name: "og:site_name", content: this.pageInfo.meta_twitter_site },
				{ name: "og:type", content: this.pageInfo.meta_og_type },
				{ name: "og:image", content: this.pageInfo.meta_og_image_url },

				{ name: "twitter:card", content: this.pageInfo.meta_twitter_card },
				{ name: "twitter:site", content: this.pageInfo.meta_twitter_site },
				{ name: "twitter:title", content: this.pageInfo.meta_twitter_title },
				{
					name: "twitter:description",
					content: this.pageInfo.meta_twitter_description
				},
				{
					name: "twitter:creator",
					content: this.pageInfo.meta_twitter_creator
				},
				{ name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }
			]
		};
	},
	created() {
		this.getAll();
		this.getPageInfo();
		this.startTime = new Date();
	},
	methods: {
		getTreeLines(dataTree) {
			return Object.keys(dataTree);
		},
		/* GET children of specific node for the given tree by the given id */
		findKey(tree, keyObj) {
			var p, key, val, tRet;
			for (p in keyObj) {
				if (keyObj.hasOwnProperty(p)) {
					key = p;
					val = keyObj[p];
				}
			}

			for (p in tree) {
				if (p === key) {
					if (tree[p] === val) {
						return tree;
					}
				} else if (tree[p] instanceof Object) {
					if (tree.hasOwnProperty(p)) {
						tRet = this.findKey(tree[p], keyObj);
						if (tRet) {
							return tRet;
						}
					}
				}
			}

			return false;
		},
		getNodeById(id) {
			return this.findKey(this.tree, { id: id });
		},
		UIDisplayQuestion(question) {
			if (!question.multi_choice) {
				this.showGoNext = false;
			} else {
				this.showGoNext = true;
			}
			this.surveyQuestions = [];
			this.surveyQuestions.push(question);
		},
		getMylistItemIndex(id) {
			var result = -1;

			this.mylist.forEach((item, index) => {
				if (item.id === id) {
					result = index;
				}
			});

			return result;
		},
		getChildrenIds(obj) {
			for (var key in obj) {
				if (obj[key] !== null && obj[key] instanceof Object) {
					if (obj.hasOwnProperty("type") && obj["type"] === "question") {
						this.childrenIds.push(obj.id);
					}
					/* Recurse into children */
					this.getChildrenIds(obj[key]);
				}
			}

			return this.childrenIds;
		},
		addOptionChildren(node) {
			let optionChildren = [];

			if (node.parent_id !== 0) {
				this.showGoBack = true;
			}

			if (node.children) {
				optionChildren = Object.values(node.children);
			}

			if (optionChildren && optionChildren.length > 0) {
				let insertedIndex = this.NodPointer;
				optionChildren.forEach(child => {
					if (this.getMylistItemIndex(child.id) === -1) {
						let oNode = this.getNodeById(child.id);
						this.mylist.splice(++insertedIndex, 0, {
							id: parseInt(child.id),
							parent: child.parent_id,
							question: oNode.title,
							option_value: [],
							selectedOptionTitle: []
						});
					}
				});
			}
		},
		multiChoose(ids, questionId) {
			this.questionNumber++;

			/* To reset the unselected options */
			let oldSelectedValues = this.mylist[
				this.getMylistItemIndex(questionId)
			].option_value.slice();

			/* Reset previous selected options for this question */
			this.mylist[this.getMylistItemIndex(questionId)].option_value = [];
			this.mylist[this.getMylistItemIndex(questionId)].selectedOptionValue = 0;

			ids.forEach(id => {
				var node = this.getNodeById(id);
				console.log("Chosen node Options :", node.title, node.id);

				// remove from oldSelectedValues
				if (oldSelectedValues.indexOf(id) > -1) {
					oldSelectedValues.splice(oldSelectedValues.indexOf(id), 1);
				}

				// set the question chosen values
				if (
					this.mylist[
						this.getMylistItemIndex(node.parent_id)
					].option_value.indexOf(id) === -1
				) {
					this.mylist[
						this.getMylistItemIndex(node.parent_id)
					].option_value.push(id);
					this.mylist[
						this.getMylistItemIndex(node.parent_id)
					].selectedOptionValue += node.value;
					this.mylist[
						this.getMylistItemIndex(node.parent_id)
					].selectedOptionTitle.push(node.title);
				}

				// add the children questions of the selected option
				this.addOptionChildren(node);
			});

			// remove the unselected options and it's children
			oldSelectedValues.forEach(id => {
				// then remove root children
				let UpParentNode = this.getNodeById(id);
				this.childrenIds = [];
				this.childrenIds = this.getChildrenIds(UpParentNode);

				// add the root element to be removed
				this.childrenIds.push(id);

				this.childrenIds.forEach(childId => {
					this.mylist.forEach((item, index) => {
						if (item.id === childId) {
							this.mylist.splice(index, 1);
						}
					});
				});
			});
		},
		next() {
			this.NodPointer++;
			this.show();
		},
		optionSelected(option, questionId) {
			this.projectEstimation += option.value;
			this.multiChoose([option.id], questionId);
			this.next();
		},
		optionCheckboxSelected($event, option, questionId) {
			this.goNextIsDisabled = false;
			if ($event.target.checked) {
				this.projectEstimation += option.value;
			} else {
				this.projectEstimation -= option.value;
			}
		},
		show() {
			if (this.NodPointer < this.mylist.length) {
				this.CurrentQuestionId = this.mylist[this.NodPointer].id;
				console.log(
					"Question : ",
					this.getNodeById(this.mylist[this.NodPointer].id).title,
					this.getNodeById(this.mylist[this.NodPointer].id).id
				);
				this.UIDisplayQuestion(
					this.getNodeById(this.mylist[this.NodPointer].id)
				);
			} else {
				console.log("USER HAVE BEEN FINISHED!");
				this.showForm = true;
			}
		},
		getCheckOptions() {
			let values = [];
			let questionId = -1;
			$(":checkbox:checked").each(function(item, i) {
				values.push(parseInt($(this).val()));
				questionId = $(this).attr("question");
			});
			return [values, questionId];
		},
		goBack() {
			let currQuestionIndex = this.getMylistItemIndex(this.CurrentQuestionId);
			let currentQuestion = this.getNodeById(this.mylist[this.NodPointer].id);
			var _self = this;
			if (this.NodPointer > currQuestionIndex) {
				this.NodPointer = currQuestionIndex;
			}
			let prevQuestion = this.getNodeById(this.mylist[--this.NodPointer].id);
			_self.mylist.forEach(function(item) {
				if (prevQuestion.title === item.question) {
					_self.projectEstimation -= item.selectedOptionValue;
					item.selectedOptionValue = 0;
					item.selectedOptionTitle = [];
					item.option_value = [];
				} else if (currentQuestion.title === item.question) {
					_self.checkedOptions.forEach(function(id) {
						if (currentQuestion.options[id] !== undefined) {
							_self.projectEstimation -= currentQuestion.options[id].value;
						}
					});
				}
			});
			_self.checkedOptions = [];
			this.UIDisplayQuestion(prevQuestion);

			this.questionNumber--;
			if (this.questionNumber === 1) {
				this.showGoBack = false;
			}
		},
		goNext() {
			let selectedOptions = this.getCheckOptions()[0];
			let questionId = Number(this.getCheckOptions()[1]);
			if (selectedOptions.length !== 0) {
				this.multiChoose(selectedOptions, questionId);
				this.next();
			} else {
				alert("choose at least one item");
			}
		},
		getPageInfo() {
			this.$http
				.get(this.$parent.$parent.apiURL + "/Pages?id=6")
				.then(function(response) {
					this.pageInfo = response.body;
					this.pageTitle = this.pageInfo.title;
				});
		},
		getAll() {
			this.$http
				.post(this.$parent.$parent.apiURL + "/quotes/get-quote")
				.then(function(response) {
					this.tree = response.body;
					this.getTreeLines(response.body).forEach(id => {
						this.initList.push(parseInt(id));
						var node = this.getNodeById(parseInt(id));
						this.mylist.push({
							id: parseInt(id),
							parent: 0,
							question: node.title,
							option_value: [],
							selectedOptionTitle: []
						});
					});
					this.show();
				});
		}
	}
};
</script>

<style scoped>
.answer__option__image {
	width: 100px;
	height: 100px;
}
@media (max-width: 46.25em) {
	.box {
		padding: 10px !important;
		display: -webkit-flex;
		display: -moz-flex;
		display: -ms-flex;
		display: -o-flex;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 10px;
	}
	.answer__option__text {
		margin: 0;
	}
	.answer__option__image {
		width: 70px;
		height: 70px;
	}
	.answer .box .answer__option__image,
	.answer input[type="radio"]:checked + .box .answer__option__text,
	.answer input[type="radio"]:hover + .box .answer__option__text,
	.answer input[type="checkbox"]:checked + .box .answer__option__text,
	.answer input[type="checkbox"]:hover + .box .answer__option__text {
		transform: translateY(0);
	}
}
</style>



// WEBPACK FOOTER //
// src/components/Pricing.vue